import * as React from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

const ErrorMessage = ({ children, className }) => (
  <AnimateHeight
    duration={ 300 }
    height={ children ? 'auto' : 0 }
  >
    <div className={`text-gpred font-medium ${className}`}>
      {children || <>&nbsp;</>} {/* Non breaking space used as placeholder to preserve animation */}
    </div>
  </AnimateHeight>
);

ErrorMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string
};

ErrorMessage.defaultProps = {
  children: null,
  className: ''
};

export default ErrorMessage;
